'use strict';

import isSuperAdmin from '../services/jwt/isSuperAdmin';

export default function superAdmin({ next, router }) {
    return isSuperAdmin(localStorage.getItem('superAdmin')) == true ? next() : next('/');
}